import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit } from '@angular/core';

import { Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle, CmsCollection, CmsTaxonomyGeneral } from '@fcom/core-api/interfaces/cms-interface';
import { isNotEmpty, safeMap } from '@fcom/core/utils';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { IconPosition } from '@fcom/ui-components';

@Component({
  selector: 'cms-discover-now',
  styleUrls: ['./cms-discover-now.component.scss'],
  templateUrl: './cms-discover-now.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsDiscoverNowComponent implements OnInit {
  private readonly themeService = inject(FinnairThemeService);

  @Input()
  content$: Observable<CmsCollection>;
  itemsObs$: Observable<CmsArticle[]>;

  public readonly SvgLibraryIcon: typeof SvgLibraryIcon = SvgLibraryIcon;
  public readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  public readonly IconPosition: typeof IconPosition = IconPosition;
  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  ngOnInit(): void {
    this.itemsObs$ = this.content$.pipe(
      map((content: CmsCollection) => safeMap(content, (c: CmsCollection) => c.items as CmsArticle[])),
      filter(isNotEmpty),
      distinctUntilChanged()
    );
  }
}
